import { FC, useCallback } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { SuspenseData } from 'components/extend/SuspenseData'
import { OrderCargoInfo, OrderItem } from 'schema'

import { useGetOrderByIdQuery } from '../api'
import { OrderDefaultDetail } from '../components/OrderDefaultDetail'
import OrderYarcheDetail from '../components/OrderYarcheDetail'
import { orderDetailRoute, orderRoute } from '../routes'

const OrderDetailPage: FC = () => {
  const navigate = useNavigate()
  const { id } = orderDetailRoute.useParams()
  const searchParams = orderDetailRoute.useSearch()

  const { data, isLoading, isError, isSuccess } = useGetOrderByIdQuery(id)

  const handleClose = useCallback(() => {
    navigate({ to: orderRoute.to, search: (prev) => ({ ...prev, ...searchParams }) })
  }, [navigate, searchParams])

  return (
    <SuspenseData data={data} isError={isError} isLoading={isLoading} isSuccess={isSuccess} onClose={handleClose}>
      {(order: OrderItem) =>
        order.cargoInfo.type === OrderCargoInfo.type.SIZE ? (
          <OrderYarcheDetail order={order} />
        ) : (
          <OrderDefaultDetail order={order} />
        )
      }
    </SuspenseData>
  )
}

export default OrderDetailPage
